export const EMPTY_EFFECT = '/assets/effects/empty';
export const EMPTY_EFFECT_TRACKING = '/assets/effects/empty_track';

export const MIN_PHONE_LENGTH = 9;
export const MAX_PHONE_LENGTH = 15;
export const ALLOWED_SIMS_FOR_PATIENT = 4;
export const ALLOWED_SIMS_LIMIT_MSG = `You can't create more than ${ALLOWED_SIMS_FOR_PATIENT} simulations. Contact Clinics manager, please`;

export enum Roles {
  NONE = 0,
  WEB_USER = 1,
  CLINIC_USER = 2,
  CLINIC_ADMIN = 3,
  CLINIC_OWNER = 4,
  SUPERADMIN = 5,
}

export enum ImagesTypes {
  PASSED = 'Pass',
  FAILED = 'Fail',
}

export enum SettingsTypes {
  INFO = 'info',
  FEATURES = 'features',
  INTEGRATION = 'integration',
}

export enum TutorialsTypes {
  TRAINING = 'training',
  SET_UP = 'setUp',
}

export enum PatientTypes {
  LEAD = 'Lead',
  CONSULTATION = 'Consultation',
}

export enum Filters {
  PATIENTS = 'patients$',
  CLINICS = 'clinics$',
  IMAGES = 'images$',
}

export enum SortingNames {
  DATE = 'date',
  NAME = 'name',
}

export enum SortingOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export enum SimulationRoutes {
  AR = 'ar',
  ML = 'ml',
  ML_SIMPLE = 'ml_simple',
}

export enum SimulationStates {
  LIVE = 'live',
  PHOTO = 'photo',
  ML = 'ml',
  ML_SIMPLE = 'mlSimple', // simV2
}

export type SimulationState = 'photo' | 'ml' | 'live' | 'mlSimple';

export enum ControlsTypes {
  MODEL = 'model',
  COLOR = 'color',
  TYPE = 'type',
  STYLE = 'style',
  REGION = 'region',
  ANIMATE = 'animate',
}

export const USER_LS_KEY = () => {
  return 'cuvln' + window.location.hostname.replace('.', '');
};

export const IMAGE_PLACEHOLDER_PATH = '/assets/img/image-placeholder.svg';

export const REGIONS = [
  {
    id: 'slot_1',
    title: 'N1',
    icon: 'r1.svg',
  },
  {
    id: 'slot_2',
    title: 'N2',
    icon: 'r2.svg',
  },
  {
    id: 'slot_3',
    title: 'N3',
    icon: 'r3.svg',
  },
];

export const LENGTH = [
  {
    id: 's',
    title: 'Short',
    disabled: true,
  },
  {
    id: 'm',
    title: 'Medium',
  },
  {
    id: 'l',
    title: 'Long',
    disabled: true,
  },
];

// 600 was temporary removed
export const volumeValues = [
  0, 1200, 1500, 1800, 2100, 2400, 2700, 3000, 3500, 4000, 4500, 5000, 5500,
];

export const TOKEN_NOT_VALID = 'token_not_valid';
export const tutorialsUrl = 'https://www.viewlabs.co/tutorial';

export const MIN_IMAGE_WIDTH = 1024;

export const activeSimulationQueryParamKey = 'sim';
export const activeImagesSetQueryParamKey = 'img';
